import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./GenericSessionCalendar.css";
import React, { useMemo } from 'react';
import { SessionScheduleView } from './SessionScheduleView'
import { EventFullInfo } from '../../../../models/event';
import { EventSessionCreationPermissionStatus } from '../../../../functions/Events';
import GSessionModal from '../../../modals/GSessions/GSessionModal';
import { ETypeNum } from '../../../../models/event/EType';


// Setup the localizer by providing the moment (or globalize, or Luxon) Object
// to the correct localizer.
const localizer = momentLocalizer(moment) // or globalizeLocalizer

export interface CalSession
{
    bgg_title_link?: string,
    owner: string,
    id: number,
    name: string,
    title: string,
    start: Date,
    end: Date,
    info: string,
    room: string,
    table: string,
    slots_available: number,
    participants: string[],
    isBackgroundEvent?: boolean
}

export interface genericSessionCalendarStrings
{
    alreadySignedUp: string, 
    buttonSignUp: string, 
    buttonRelinquish: string,
    userNotLoggedIn: string, 
    userNotRegistered: string, 
    userNotRegisteredButton: string, 
    userNotPermittedToCreate: string, 
    userPermittedToCreate: string 
}

interface genericSessionCalendarProps
{
    seshList: CalSession[],
    onSignUp: (sesh: CalSession) => Promise<boolean>,
    onRelinquish: (sesh: CalSession) => Promise<boolean>,
    userStatus:  EventSessionCreationPermissionStatus,
    userId?: number,
    userName?: string,
    token?: string,
    event: EventFullInfo,
    displayStrings?: genericSessionCalendarStrings,
    onEventRSVP: () => Promise<boolean>,
    refreshSessions: () => void
}

interface tableResource {
    id: number,
    title: string
}

const GenericSessionCalendar = (props: genericSessionCalendarProps) =>
{

    const user_status = props.userStatus;
    
    const display_strings = props.displayStrings ? props.displayStrings :
    {
        alreadySignedUp: "You are already signed up to this session.",
        buttonSignUp: "Click here to sign up to this session",
        buttonRelinquish: "Click here to relinquish slot.",
        userNotLoggedIn: "You are not logged in! Log into TGA to access RSVP features!",
        userNotRegistered: "You have not RSVPed to this event!",
        userNotRegisteredButton: "Click here to RSVP to this event!",
        userNotPermittedToCreate: "You are not yet permitted to create sessions for this event.",
        userPermittedToCreate: "You may now sign up for and create Sessions!"
    }

    const [selectedSession, setSelectedSession] = React.useState<CalSession|undefined>(undefined);
    const [seshRangeStart, setSeshRangeStart] = React.useState<moment.Moment>(props.event.start_DateTime);
    const [seshRangeEnd, setSeshRangeEnd] = React.useState<moment.Moment>(props.event.end_DateTime);
    const [tableResources, setTableResources] =React.useState<tableResource[]>([]);
    const [resourceView, setResourceView] =React.useState<boolean>(false);
    const [modalState, setModalState] = React.useState<boolean>(false);

    React.useEffect(()=>
    {
        const selsession = props.seshList.filter((sesh)=>{
            return selectedSession && (sesh.id === selectedSession.id)
        })
        if (selsession.length === 1)
        {
            setSelectedSession(selsession[0]);
        }
        else
        {
            setSelectedSession(undefined);
        }

    },[props.seshList])

    React.useEffect(() => {
        if(!props.event.lowest_Table_Number || !props.event.highest_Table_Number) {
            return;
        }
        let resourceBuilder = [];
        for(let i=props.event.lowest_Table_Number; i <= props.event.highest_Table_Number; i++) {
            resourceBuilder.push({id: i, title: "Table " + i.toString()});
        }
        setTableResources(resourceBuilder);
    },[])

    const evtList = props.seshList;

    const { startDate, endDate, views } = useMemo(
        () => ({
            startDate: props.event.start_DateTime,
            endDate: props.event.end_DateTime,
            views: {
                month: true,
                week: SessionScheduleView,
                day: true
            }
        }),
        []
    );

/* from titanbuster-event-page branch commit 94c159389ef4a4fbee16be05d9f52ff01c3f759e
    const eventSelected = (event: any): any =>
    {
        if(event.isBackgroundEvent === false)
        {
            const eventObj: CalEvent = event;
            setSelectedEvent(eventObj);
            setRangeStart(eventObj.start);
            setRangeEnd(eventObj.end);
        } 
    };
*/

    const seshSelected = (sesh: any): any =>
    {
        if(sesh.isBackgroundEvent !== false) {
            const seshObj: CalSession = sesh;
            setSelectedSession(seshObj);
            setSeshRangeStart(moment(seshObj.start));
            setSeshRangeEnd(moment(seshObj.end));
            setModalState(true);
        } 
        
        
    };


    const slotSelected = (range: { start: Date, end: Date }):boolean =>
    {
        setSelectedSession(undefined);
        setSeshRangeStart(moment(range.start));
        setSeshRangeEnd(moment(range.end));
        return true;
    }


    //TODO: only display if multi-day Event.
    const backgroundEvent: any =
    {
        start: props.event.start_DateTime,
        end: props.event.end_DateTime
    }


    const showRSVP = (sesh: CalSession, user: string) =>
    {
        if(sesh.participants.includes(user))
        {
            return <div><b>{display_strings.alreadySignedUp}</b><button className="buttonPrimary" onClick={() => props.onRelinquish(sesh)}>{display_strings.buttonRelinquish}</button></div>
        }
        else
        {
            return <button
                className="buttonPrimary"
                onClick={() => props.onSignUp(sesh)}
            >{display_strings.buttonSignUp}</button>
        }
    }

    const onEventRsvp = () =>
    {
        props.onEventRSVP();
    }

    const user_header = (sta:  EventSessionCreationPermissionStatus) =>
    {
        switch (sta)
        {
            case  EventSessionCreationPermissionStatus.notAUser:
                return <b>{display_strings.userNotLoggedIn}</b>;
            case  EventSessionCreationPermissionStatus.notAttendingEvent:
                if(props.event.eType === ETypeNum.Premiere)
                {
                    return <div></div>
                }
                //else
                return <div><b>{display_strings.userNotRegistered}</b><button className="buttonPrimary" onClick={onEventRsvp}>{display_strings.userNotRegisteredButton}</button></div>;
            case  EventSessionCreationPermissionStatus.noSessionPermissions:
                return <b>{display_strings.userNotPermittedToCreate}</b>
            case  EventSessionCreationPermissionStatus.canCreateSessions:
                return <b>{display_strings.userPermittedToCreate}</b>;
            default:
                return <b>Something Bad has occured if you're seeing this.</b>

        }

    }

    const generateTitle = (evt: CalSession) => 
    {
        return evt.table ? "Table " + evt.table.toString() + ": " + evt.name : "";
    }




    const requestModalClose = () => {
        setModalState(false);
    }

    const refreshSessionInfo = () => {
        props.refreshSessions();
    }

    const reqModalCreate = () => {
        setSelectedSession(undefined);
        setModalState(true);
    }





    return <div>
        <div>
            {user_header(user_status)}
            <p></p>
        </div>
        {props.event.session_lock && <b>Session Calendar will be locked at {moment(props.event.session_lock).format('LLLL')}</b>}
        <p></p>
        <button className="buttonPrimary" onClick={() => setResourceView(!resourceView)}>Change View</button>
        <p></p>
        <div className="myCustomHeight">
            {resourceView ? 
            <Calendar
                date={startDate.toDate()}
                min={startDate.toDate()}
                max={endDate.toDate()}
                localizer={localizer}
                startAccessor="start"
                endAccessor="end"
                view="week"
                views={views}
                events={evtList}
                onSelectEvent={seshSelected}
                toolbar={false}
                onSelecting={slotSelected}
                titleAccessor={generateTitle}
                resources={tableResources}
                resourceAccessor={'table'}
            /> :
            <Calendar
                date={startDate.toDate()}
                min={startDate.toDate()}
                max={endDate.toDate()}
                localizer={localizer}
                startAccessor="start"
                endAccessor="end"
                view="week"
                views={views}
                events={evtList}
                onSelectEvent={seshSelected}
                toolbar={false}
                onSelecting={slotSelected}
                titleAccessor={generateTitle}
            />}
        </div>
        <br></br>
        {selectedSession && <GSessionModal
                modalState = {modalState}
                requestClose = {requestModalClose}
                focusSession={{...selectedSession, slots: selectedSession? selectedSession.slots_available : 0, owner_player: false, evt: props.event.id}}
                event={props.event}
                user_id={props.userId}
                token={props.token}
                user_name={props.userName}
                playerNames = {selectedSession?.participants}
                refreshSessions = {refreshSessionInfo}
        />}
        {!selectedSession && <GSessionModal
                modalState = {modalState}
                requestClose = {requestModalClose}
                event={props.event}
                user_id={props.userId}
                token={props.token}
                user_name={props.userName}
                refreshSessions = {refreshSessionInfo}
        />}
        <br></br>
        <hr></hr>
        <br></br>
        {props.userStatus > 2 && props.userId && props.token && (!props.event.session_lock || moment(props.event.session_lock) > moment(new Date())) && <button className="buttonPrimary" onClick={reqModalCreate}>Create Session</button>}
        </div>
}

export default GenericSessionCalendar;